import page from './page'
import {initSeoContentBlocks} from '../components/cms-seo-content-block';

page('.component-library', () => {
  initSeoContentBlocks();
});
